import {inject, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UIHelperComponent} from 'frontier/browserkit/src/lib/components/ui-helper/ui-helper-component.interface';
import {Overlay, OverlayConfig} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {
  UiHelperContentComponent
} from 'frontier/browserkit/src/lib/components/ui-helper/ui-helper-content/ui-helper-content.component';

@Injectable({
  providedIn: 'root'
})
export class UiHelperService {
  openedHelp$ = new BehaviorSubject<UIHelperComponent>(null);

  private _overlay = inject(Overlay);

  private _config = new OverlayConfig(
    {
      height: 'calc(100% - 50px)', // Minuend has to match margin-top of .ui-helper-panel in
      // ui-helper-content.component.css
      width: 300,
      positionStrategy: this._overlay.position().global().right('0'),
      panelClass: ['ui-helper-panel', 'mat-elevation-z2'],
    }
  )

  private _overlayRef = this._overlay.create(this._config);

  openHelp(config: UIHelperComponent) {
    const uiHelperContentComponentPortal = new ComponentPortal(UiHelperContentComponent);
    this._overlayRef.detach();
    this._overlayRef.attach(uiHelperContentComponentPortal);
    this.openedHelp$.next(config);

    setTimeout(() => {
      this._overlayRef.addPanelClass('visible');
    });
  }

  close() {
    this._overlayRef.removePanelClass('visible');

    // Wait for animation to complete before detaching
    setTimeout(() => {
      this._overlayRef.detach();
    }, 300);
  }
}
